import { View, StyleSheet } from 'react-native'
import { ThemedShared, ThemedValues } from 'styles/themed'
import { colorList } from 'utils/colors'

const ButtonGroup = ({ style, onLayout, children }) => {

    return (
        <View 
            onLayout={ onLayout }
            style={[ styles.container, style ] }>
                
            { children }
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: ThemedShared.paddingSmall.padding,
        backgroundColor: colorList.PRIMARY.light,
        borderRadius: ThemedValues.borderRadius,
        gap: 5
    },  
})

export default ButtonGroup